import { render, staticRenderFns } from "./WorkCalendarEditDialog.vue?vue&type=template&id=2bc12545&scoped=true"
import script from "./WorkCalendarEditDialog.vue?vue&type=script&lang=js"
export * from "./WorkCalendarEditDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarEditDialog.vue?vue&type=style&index=0&id=2bc12545&prod&scoped=true&lang=css"
import style1 from "./WorkCalendarEditDialog.vue?vue&type=style&index=1&id=2bc12545&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc12545",
  null
  
)

export default component.exports